import { GDTApiErrors } from '@/types';
import {
  RequestAgregarJugadorF5,
  RequestDesignarAseguradoJugadorF5,
  RequestDesignarCapitanJugadorF5,
  RequestEliminarJugadorF5,
  ResponseEquipoConfirmado,
  ResponseGetInitBuildF5,
} from '@/types/team';
import { TEXTS, URLs, axiosErrorHandler } from '@/utils';
import axiosGdt from '@/utils/axiosGdt';

export const getInitBuildTeam5 = axiosErrorHandler(async () => {
  const url = URLs.ARMA_EQUIPO_F5.INIT;
  const response = await axiosGdt.get<ResponseGetInitBuildF5 | GDTApiErrors>(
    url
  );
  return response.data;
}, TEXTS.getTeamData);

export const addPlayer = axiosErrorHandler(
  async ({ idJugadorTorneo }: RequestAgregarJugadorF5) => {
    const url = `${URLs.ARMA_EQUIPO_F5.AGREGAR_JUGADOR}?idJugadorTorneo=${idJugadorTorneo}`;
    const response = await axiosGdt.post<ResponseGetInitBuildF5 | GDTApiErrors>(
      url
    );
    return response.data;
  },
  'Error al guardar jugador'
);

export const removePlayer = axiosErrorHandler(
  async ({ idJugadorTorneoSaliente }: RequestEliminarJugadorF5) => {
    const url = `${URLs.ARMA_EQUIPO_F5.ELIMINAR_JUGADOR}?idJugadorTorneoSaliente=${idJugadorTorneoSaliente}`;
    const response = await axiosGdt.post<ResponseGetInitBuildF5 | GDTApiErrors>(
      url
    );
    return response.data;
  },
  'Error al eliminar jugador'
);

export const saveTeam = axiosErrorHandler(async () => {
  const url = URLs.ARMA_EQUIPO_F5.CONFIRMAR;
  const response = await axiosGdt.post(url);
  return response.data;
}, TEXTS.saveTeam);

export const setCaptain = axiosErrorHandler(
  async ({ idJugadorTorneo }: RequestDesignarCapitanJugadorF5) => {
    const url = `${URLs.ARMA_EQUIPO_F5.SELECCIONAR_CAPITAN}?idJugadorTorneo=${idJugadorTorneo}`;
    const response = await axiosGdt.post<ResponseGetInitBuildF5 | GDTApiErrors>(
      url
    );
    return response.data;
  },
  'Error al  guardar jugador capitán'
);

export const setInsured = axiosErrorHandler(
  async ({ idJugadorTorneo }: RequestDesignarAseguradoJugadorF5) => {
    const url = `${URLs.ARMA_EQUIPO_F5.SELECCIONAR_ASEGURADO}?idJugadorTorneo=${idJugadorTorneo}`;
    const response = await axiosGdt.post<ResponseGetInitBuildF5 | GDTApiErrors>(
      url
    );
    return response.data;
  },
  'Error al  guardar jugador asegurado'
);

export const confirmedTeamInfoF5 = axiosErrorHandler(async () => {
  const url = URLs.ARMA_EQUIPO_F5.INFO_EQUIPO_CONFIRMADO;
  const response = await axiosGdt.get<ResponseEquipoConfirmado | GDTApiErrors>(
    url
  );
  return response.data;
}, 'No puedo obtener información del equipo Fútbol 5');
